// src/components/Header.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../firebase'; // Verifique se seu firebase.js está configurado
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { useAuth } from '../context/AuthContext'; // Você precisará criar este contexto depois
import { useCart } from '../context/CartContext';      // NOVO: Importa o contexto do carrinho
import { FaShoppingCart } from 'react-icons/fa';   // NOVO: Importa o ícone
import logo from '../assets/logo.png'; // Coloque seu logo na pasta assets
import '../App.css'; // Usaremos um CSS geral por enquanto
import './Header.css';

const Header = () => {
  const { currentUser, userRole } = useAuth();
  const { cartCount } = useCart();
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      // O redirecionamento será tratado pelo AuthContext
    } catch (error) {
      console.error("Erro ao fazer login com Google:", error);
      alert(`Erro ao fazer login: ${error.message}`);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    }
  };

  return (
    <header className="main-header">
      <div className="container">
        <Link to="/"><img src={logo} alt="Logo da Primo Trade Solutions" className="logo-image" /></Link>
        <nav>
          <Link to="/" className="nav-link">Início</Link>
          
          <div className="nav-dropdown">
            <span className="nav-link" style={{cursor: 'pointer'}}>Soluções</span>
            <div className="dropdown-content">
              <Link to="/produtos/intelbras">Produtos Intelbras</Link>
              <Link to="/para-seu-negocio">Para seu Negócio</Link>
              <Link to="/solucoes/para-seu-condominio">Para seu Condomínio</Link>
              <Link to="/solucoes/carregadores-veiculares">Carregadores Veiculares</Link>
              <Link to="/paineis-de-led">Painéis de LED</Link>
              <Link to="/solucoes/poste-cftv">Poste CFTV</Link>
              
              
            </div>
          </div>
          <Link to="/servicos" className="nav-link">Serviços</Link>
          {/* --- O BLOCO DE CÓDIGO ABAIXO FOI OCULTADO (COMENTADO) --- */}
          {/*
          <div className="nav-dropdown">
            <span className="nav-link" style={{cursor: 'pointer'}}>Sensores</span>
            <div className="dropdown-content">
              <Link to="/sensores/novotechnik">Novotechnik</Link>
            </div>
          </div>
          */}
          
          {currentUser ? (
            <div className="nav-dropdown">
              <span className="nav-link" style={{cursor: 'pointer'}}>{currentUser.displayName}</span>
              <div className="dropdown-content">
                {userRole === 'admin' ? (
                  <Link to="/admin/dashboard">Painel Admin</Link>
                ) : (
                  <Link to="/dashboard">Meu Painel</Link>
                )}
                <button 
                  onClick={handleLogout} 
                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '12px 16px', width: '100%', textAlign: 'left', color: 'black', fontFamily: 'inherit', fontSize: '0.9rem' }}
                >
                  Sair
                </button>
              </div>
            </div>
          ) : (
            <button onClick={handleGoogleLogin} className="nav-link" style={{background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit'}}>
                Entrar
            </button>
          )}
          <Link to="/carrinho" className="nav-cart-link">
            <FaShoppingCart />
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;